import { ProcessDefinition } from '../../types';
import { ValidationIssue, ValidationContext } from './types';
import { getRules } from './registry';

// Rule-module imports. Each module calls registerRule at load time.
// Keep this list in sync with files in ./rules/. Sections that are not yet
// implemented are intentionally absent — framework functions with zero rules.
import './rules/section_1_nodes';
import './rules/section_2_sequence_flows';
import './rules/section_3_cardinality';
import './rules/section_4_gateways';
import './rules/section_5_start_events';
import './rules/section_6_end_events';
import './rules/section_7_intermediate_events';
import './rules/section_8_boundary_events';
import './rules/section_9_activities';
import './rules/section_10_call_activity';
import './rules/section_11_scripts_resources';
import './rules/section_12_diagram_process';
import './rules/section_13_reachability';

export * from './types';
export { getRules, getRule } from './registry';

export const validateDiagram = (processes: ProcessDefinition[]): ValidationIssue[] => {
  const ctx: ValidationContext = { processes };
  const issues: ValidationIssue[] = [];

  for (const rule of getRules()) {
    try {
      if (rule.scope === 'diagram') {
        issues.push(...rule.run(ctx));
      } else {
        for (const proc of processes) {
          const procIssues = rule.run(ctx, proc);
          procIssues.forEach(i => {
            if (!i.processId) i.processId = proc.id;
          });
          issues.push(...procIssues);
        }
      }
    } catch (err) {
      console.error(`[validation] Rule ${rule.id} threw:`, err);
      issues.push({
        severity: 'error',
        rule: rule.id,
        message: `Validation rule ${rule.id} crashed: ${err instanceof Error ? err.message : String(err)}`,
      });
    }
  }

  return issues;
};

export const hasBlockingErrors = (issues: ValidationIssue[]): boolean =>
  issues.some(i => i.severity === 'error');

export const summarize = (issues: ValidationIssue[]): { errors: number; warnings: number } => ({
  errors: issues.filter(i => i.severity === 'error').length,
  warnings: issues.filter(i => i.severity === 'warning').length,
});
